import * as t from "io-ts";
import { CallResponseSchemaNoData } from "../common/callResponseSchema";

const pair = { project_id: t.string, source: t.string, target: t.string };

export const LocizeVersionRequestSchema = t.union([
  t.type({ action: t.literal("info") }),
  t.type({ action: t.literal("compare"), ...pair }),
  t.type({ action: t.literal("overwrite"), ...pair, confirmation: t.literal("overwrite-version"), fingerprint: t.string }),
  t.type({
    action: t.literal("publish"),
    project_id: t.string,
    target: t.string,
    overwrite_job_id: t.string,
    confirmation: t.literal("publish-version"),
  }),
  t.type({ action: t.literal("status"), project_id: t.string, job_id: t.string }),
]);

export const LocizeDifferenceSchema = t.type({
  language: t.string,
  namespace: t.string,
  key: t.union([t.string, t.null]),
  kind: t.keyof({ added: null, removed: null, changed: null }),
  source_value: t.union([t.string, t.null]),
  target_value: t.union([t.string, t.null]),
});

export const LocizeComparisonSchema = t.type({
  source: t.string,
  target: t.string,
  fingerprint: t.string,
  total: t.number,
  added: t.number,
  removed: t.number,
  changed: t.number,
  differences: t.array(LocizeDifferenceSchema),
  truncated: t.boolean,
});

export type LocizeComparison = t.TypeOf<typeof LocizeComparisonSchema>;
export type LocizeDifference = t.TypeOf<typeof LocizeDifferenceSchema>;

export const LocizeVersionResponseSchema = t.intersection([
  t.type({
    data: t.intersection([
      t.type({
        project_id: t.string,
        status: t.keyof({ ready: null, running: null, complete: null, failed: null }),
        job_id: t.union([t.string, t.null]),
      }),
      t.partial({ versions: t.array(t.string), comparison: LocizeComparisonSchema }),
    ]),
  }),
  CallResponseSchemaNoData,
]);
export type LocizeVersionResponseType = t.TypeOf<typeof LocizeVersionResponseSchema>;

export const LocizeApis = {
  Locize: { ManageVersions: { Name: "admin-locizeVersions", Request: LocizeVersionRequestSchema, Response: LocizeVersionResponseSchema } },
};
